"use client";

import AgentActionLink from "@/components/agent-actions/AgentActionLink";
import { extractActionLinks } from "@/lib/agent-actions/action-links";
import { cn } from "@/lib/utils";

/**
 * The "open this" chips beneath an assistant reply.
 *
 * Every in-app link the assistant wrote is lifted out of her markdown and
 * offered as a chip, so the destination is a button rather than a phrase to
 * find inside a paragraph. `extractActionLinks` checks each href against the
 * navigation manifest, so a page she invented never becomes a chip (SAL-2904).
 *
 * Shared by the home hero and by `AIChat`'s default message rendering — one
 * affordance, so "the assistant is sending you somewhere" looks the same
 * wherever it happens.
 */
export default function AgentActionLinks({ content, className }) {
  const links = extractActionLinks(content);
  if (!links.length) return null;

  return (
    <div className={cn("flex flex-wrap gap-2", className)}>
      {links.map((link) => (
        <AgentActionLink key={link.href} href={link.href}>
          {link.label}
        </AgentActionLink>
      ))}
    </div>
  );
}
